import { render, staticRenderFns } from "./ProjectNameLink.vue?vue&type=template&id=1c15651d&scoped=true"
import script from "./ProjectNameLink.vue?vue&type=script&lang=js"
export * from "./ProjectNameLink.vue?vue&type=script&lang=js"
import style0 from "./ProjectNameLink.vue?vue&type=style&index=0&id=1c15651d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c15651d",
  null
  
)

export default component.exports